/**=========================================================
 * Module: login.js
 * Login Controller
 =========================================================*/

App.controller('EnableController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular', '$filter', '$http',
  function($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R, $filter, $http) {
    "use strict";
    
    $scope.password = "";
    $scope.enable = $state.params.enable;
    $scope.id = $state.params.id;

    $scope.result = '';
    
    R.one('account', $scope.id).put({ jsonData: { action: 'EnableAccount', enable: $scope.enable }})
        .then(function(response){
            if(response.id == $scope.id){
                $scope.result = 'enabled';
            } else {
                $scope.result = 'notenabled';
            }
        })
        .catch(function(err){
            $scope.result = 'notenabled'
        })

  }
]);
